import { useMemo, useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { CmmOrderTableRowData } from "../../../../data-model/cmmOrderTableRowData";
import { ModalId } from "../../../../enums/modalId";
import { OrganizationType } from "../../../../enums/organizationTypes";
import { CopyIcon } from "../../../../svg/copy-icon";
import { calculateAge } from "../../../../utils/ageCalculator";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import SideNavElement from "../../../sideNavElement/sideNavElement";
import AsteraImageTab from "./components/asteraImageTab";
import MedicationLogic from "./components/medicationLogic";
import PrescriptionImage from "./components/presciptionImage";
import Prescription from "./components/prescription";

interface ExpandableTableRowMedicationProps {
  onClose: () => void;
  rowData?: CmmOrderTableRowData;
}

const baseTabs = [
  { id: "prescription-image", label: "Prescription Image" },
  { id: "prescription", label: "Prescription" },
  { id: "medication-logic", label: "Medication Logic" },
];

const asteraImageTab = { id: "astera-image", label: "Astera Image" };

const ExpandableTableRowMedication = ({
  onClose,
  rowData,
}: ExpandableTableRowMedicationProps) => {
  const orgId = getOrgIdForFetchExternalWorklist();
  const isAstera = orgId === OrganizationType.ASTERA;

  const tabs = useMemo(
    () => (isAstera ? [...baseTabs, asteraImageTab] : baseTabs),
    [isAstera],
  );

  const [selectedTab, setSelectedTab] = useState<string>("prescription-image");
  console.log("rowData", rowData);

  const renderContent = () => {
    switch (selectedTab) {
      case "prescription-image":
        return <PrescriptionImage rowData={rowData} />;
      case "prescription":
        return <Prescription rowData={rowData} />;
      case "medication-logic":
        return <MedicationLogic rowData={rowData} />;
      case "astera-image":
        return (
          <AsteraImageTab identifier={rowData?.id ?? ""} rowData={rowData} />
        );
      default:
        return null;
    }
  };
  return (
    <Modal
      dialogId={ModalId.EXPANDABLE_TABLE_ROW_MEDICATION_MODAL}
      onSave={onClose}
      title={"Medication"}
      saveButtonText={"Close"}
      cancelText={"Cancel"}
      onCancel={onClose}
      onClose={onClose}
      heightPercentage={90}
      showSingleButton={true}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        <div className="flex w-full items-center gap-2 border-b border-primaryGray-15 pb-3">
          <div className="mx-2 rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
            {rowData?.patientDetails?.mainText ?? "N/A"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.patientId ?? "N/A"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.dateOfBirth?.mainText ?? "N/A"} (
            {calculateAge(rowData?.dateOfBirth?.mainText)} yrs) &nbsp;&nbsp;
            <span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.medication?.split(" ")[0] ?? "N/A"}
          </div>
          {rowData?.type != null &&
            rowData.type !== "--" &&
            rowData.type !== "" && (
              <div className="rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
                {rowData.type}
              </div>
            )}

          <div className="cmm-result-key mx-2 ml-auto flex items-center gap-2 text-small">
            CMM Key:{" "}
            <span className="font-bold">
              {rowData?.cmmKey ?? "N/A"}
              &nbsp;
            </span>
            <div
              className="cmm-result-key copy-icon hover:cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(rowData?.cmmKey ?? "");
              }}
            >
              <CopyIcon />
            </div>
          </div>
        </div>

        <div className="flex flex-1 gap-1 overflow-hidden">
          <div className="side-nav--container flex w-[25%] flex-col overflow-y-auto">
            {tabs.map((tab) => (
              <SideNavElement
                key={tab.id}
                id={tab.id}
                label={tab.label}
                active={tab.id === selectedTab}
                onSelect={(id) => setSelectedTab(id)}
              />
            ))}
          </div>
          <div className="content--container flex h-full w-[75%] flex-1 flex-col pb-3">
            {renderContent()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExpandableTableRowMedication;
